// extracted by mini-css-extract-plugin
export var closeButton = "_n1-2";
export var closeButtonIcon = "_n1-3";
export var lightboxContent = "_n1-1";
export var lightboxOverlay = "_n1-0";